import * as actions from './actions';

const initialState = {
    // Archives list
    archives: [],
    loadingArchives: false,
    errorArchives: null,

    // Archive detail
    currentArchive: null,
    loadingArchiveDetail: false,
    errorArchiveDetail: null,

    // Upload
    loadingUpload: false,
    errorUpload: null,

    // Download
    loadingDownload: false,
    errorDownload: null,

    // Storage stats
    storageStats: null,
    loadingStorageStats: false,
    errorStorageStats: null,

    // UI State
    filters: {
        organization: '',
        category: '',
        tags: '',
        file_type: '',
        uploaded_by: '',
        related_batch: '',
        related_recipe: '',
        related_spawn: '',
        related_note: '',
        search: '',
        active: true,
        date_from: '',
        date_to: ''
    },
    selectedArchive: null,
    uploadDialogOpen: false,
};

export default function archivesReducer(state = initialState, action) {
    switch (action.type) {
        // ==================== FETCH ARCHIVES ====================
        case actions.FETCH_ARCHIVES.REQUEST:
            return { ...state, loadingArchives: true, errorArchives: null };

        case actions.FETCH_ARCHIVES.SUCCESS:
            return {
                ...state,
                archives: action.payload,
                loadingArchives: false,
                errorArchives: null
            };

        case actions.FETCH_ARCHIVES.FAILURE:
            return { ...state, loadingArchives: false, errorArchives: action.payload };

        // ==================== FETCH ARCHIVE DETAIL ====================
        case actions.FETCH_ARCHIVE_DETAIL.REQUEST:
            return { ...state, loadingArchiveDetail: true, errorArchiveDetail: null };

        case actions.FETCH_ARCHIVE_DETAIL.SUCCESS:
            return {
                ...state,
                currentArchive: action.payload,
                loadingArchiveDetail: false,
                errorArchiveDetail: null
            };

        case actions.FETCH_ARCHIVE_DETAIL.FAILURE:
            return { ...state, loadingArchiveDetail: false, errorArchiveDetail: action.payload };

        // ==================== UPLOAD ARCHIVE ====================
        case actions.UPLOAD_ARCHIVE.REQUEST:
            return { ...state, loadingUpload: true, errorUpload: null };

        case actions.UPLOAD_ARCHIVE.SUCCESS:
            return {
                ...state,
                archives: [action.payload, ...state.archives],
                loadingUpload: false,
                errorUpload: null,
                uploadDialogOpen: false
            };

        case actions.UPLOAD_ARCHIVE.FAILURE:
            return { ...state, loadingUpload: false, errorUpload: action.payload };

        // ==================== UPDATE ARCHIVE ====================
        case actions.UPDATE_ARCHIVE.REQUEST:
            return { ...state, loadingArchives: true, errorArchives: null };

        case actions.UPDATE_ARCHIVE.SUCCESS:
            return {
                ...state,
                archives: state.archives.map(archive =>
                    archive.id === action.payload.id ? action.payload : archive
                ),
                currentArchive: action.payload.id === state.currentArchive?.id
                    ? action.payload
                    : state.currentArchive,
                loadingArchives: false,
                errorArchives: null
            };

        case actions.UPDATE_ARCHIVE.FAILURE:
            return { ...state, loadingArchives: false, errorArchives: action.payload };

        // ==================== DELETE ARCHIVE ====================
        case actions.DELETE_ARCHIVE.REQUEST:
            return { ...state, loadingArchives: true, errorArchives: null };

        case actions.DELETE_ARCHIVE.SUCCESS:
            return {
                ...state,
                archives: state.archives.filter(archive => archive.id !== action.payload.archiveId),
                currentArchive: state.currentArchive?.id === action.payload.archiveId
                    ? null
                    : state.currentArchive,
                loadingArchives: false,
                errorArchives: null
            };

        case actions.DELETE_ARCHIVE.FAILURE:
            return { ...state, loadingArchives: false, errorArchives: action.payload };

        // ==================== DOWNLOAD ARCHIVE ====================
        case actions.DOWNLOAD_ARCHIVE.REQUEST:
            return { ...state, loadingDownload: true, errorDownload: null };

        case actions.DOWNLOAD_ARCHIVE.SUCCESS:
            return { ...state, loadingDownload: false, errorDownload: null };

        case actions.DOWNLOAD_ARCHIVE.FAILURE:
            return { ...state, loadingDownload: false, errorDownload: action.payload };

        // ==================== UI STATE ====================
        case actions.SET_ARCHIVE_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };

        case actions.CLEAR_ARCHIVE_DETAIL:
            return {
                ...state,
                currentArchive: null,
                errorArchiveDetail: null
            };

        case actions.SET_SELECTED_ARCHIVE:
            return {
                ...state,
                selectedArchive: action.payload
            };

        case actions.SET_UPLOAD_DIALOG_OPEN:
            return {
                ...state,
                uploadDialogOpen: action.payload
            };

        // ==================== STORAGE STATS ====================
        case actions.FETCH_STORAGE_STATS.REQUEST:
            return { ...state, loadingStorageStats: true, errorStorageStats: null };

        case actions.FETCH_STORAGE_STATS.SUCCESS:
            return {
                ...state,
                storageStats: action.payload,
                loadingStorageStats: false,
                errorStorageStats: null
            };

        case actions.FETCH_STORAGE_STATS.FAILURE:
            return { ...state, loadingStorageStats: false, errorStorageStats: action.payload };

        default:
            return state;
    }
}
